import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent, Typography, Box, Skeleton, useTheme } from '@mui/material';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const AdminRevenueChart = ({ data = [], isLoading }) => {
    // Expected data format: [{ day: 'Mon', amount: 1200 }, ...]
    const chartData = Array.isArray(data) ? data : [];
    const theme = useTheme();

    return (
        <Card sx={{ borderRadius: 3, height: '100%', boxShadow: '0 4px 20px rgba(0,0,0,0.05)' }}>
            <CardContent>
                <Typography variant="h6" fontWeight={700} mb={3}>
                    Revenue & GMV Trends
                </Typography>
                {isLoading ? (
                    <Skeleton variant="rectangular" height={300} width="100%" sx={{ borderRadius: 2 }} />
                ) : (
                    <Box sx={{ height: 300, width: '100%' }}>
                        <ResponsiveContainer width="100%" height="100%">
                            <AreaChart data={chartData} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
                                <defs>
                                    <linearGradient id="colorAdminRev" x1="0" y1="0" x2="0" y2="1">
                                        <stop offset="5%" stopColor={theme.palette.primary.main} stopOpacity={0.1} />
                                        <stop offset="95%" stopColor={theme.palette.primary.main} stopOpacity={0} />
                                    </linearGradient>
                                </defs>
                                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f0f0f0" />
                                <XAxis dataKey="day" axisLine={false} tickLine={false} tick={{ fontSize: 12, fill: '#9e9e9e' }} />
                                <YAxis
                                    axisLine={false}
                                    tickLine={false}
                                    tick={{ fontSize: 12, fill: '#9e9e9e' }}
                                    tickFormatter={(v) => `₦${v >= 1000 ? v / 1000 + 'k' : v}`}
                                />
                                <Tooltip
                                    contentStyle={{ borderRadius: '8px', border: 'none', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}
                                    formatter={(v) => [`₦${v.toLocaleString()}`, 'Revenue']}
                                />
                                <Area
                                    type="monotone"
                                    dataKey="amount"
                                    stroke={theme.palette.primary.main}
                                    fillOpacity={1}
                                    fill="url(#colorAdminRev)"
                                    strokeWidth={3}
                                />
                            </AreaChart>
                        </ResponsiveContainer>
                    </Box>
                )}
            </CardContent>
        </Card>
    );
};

AdminRevenueChart.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.shape({
            day: PropTypes.string,
            amount: PropTypes.number
        })
    ),
    isLoading: PropTypes.bool
};

export default AdminRevenueChart;
